// 會員路由
const name = '設置'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/merchant/setting',
  component: Layout,
  children: [
    {
      path: 'Merchantstaff',
      name: `帳號管理-店鋪管理員`,
      component: () => import('@/view/base/account/storestaff')
      // component: () => import('@/view/base/exportlog/index')
    },
    {
      path: 'account',
      name: `帳號管理-商戶帳號管理`,
      component: () => import('@/view/mall/marketing/merchantAccount')
    },

    {
      path: 'baseexport',
      name: `匯出列表`,
      component: () => import('@/view/base/exportlog/index')
    },

    {
      path: 'operatorlogs',
      name: `操作日誌`,
      component: () => import('@/view/base/setting/companys/logs')
    },

    {
      path: 'datapassapprove',
      name: '權限申請',
      component: () => import('@/view/base/encrypt/authAdmin.vue')
    },
    {
      path: 'datapassapply',
      name: `權限審批`,
      component: () => import('@/view/base/setting/authorityapproval'),
      children: [
        {
          path: 'approve/:id?',
          component: () => import('@/view/base/setting/authorityapproval/approve')
        }
      ]
    },
    {
      path: 'information',
      name: `訊息場景`,
      component: () => import('@/view/base/setting/information')
    }
  ]
}
